import React, { useEffect, useState } from 'react';

export interface ToastEventDetail {
  message: string;
  type?: 'success' | 'error' | 'info';
  duration?: number;
}

const Toast: React.FC = () => {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState('');
  const [type, setType] = useState<'success' | 'error' | 'info'>('info');

  useEffect(() => {
    const handleShowToast = (event: CustomEvent<ToastEventDetail>) => {
      const { message, type = 'info', duration = 3000 } = event.detail;
      setMessage(message);
      setType(type);
      setShow(true);

      setTimeout(() => {
        setShow(false);
      }, duration);
    };

    window.addEventListener('show-toast', handleShowToast as EventListener);

    return () => {
      window.removeEventListener('show-toast', handleShowToast as EventListener);
    };
  }, []);

  if (!show) return null;

  const getBackgroundColor = () => {
    switch (type) {
      case 'success':
        return 'bg-green-500';
      case 'error':
        return 'bg-red-500';
      default:
        return 'bg-blue-500';
    }
  };

  return (
    <div className={`fixed top-4 left-1/2 transform -translate-x-1/2 z-50 px-6 py-3 rounded-lg shadow-lg text-white transition-all duration-300 ease-in-out ${getBackgroundColor()} flex items-center gap-2`}>
      {type === 'error' && (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )}
      {type === 'success' && (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      )}
      <span className="font-medium">{message}</span>
    </div>
  );
};

export const showToast = (message: string, type: 'success' | 'error' | 'info' = 'info', duration = 3000) => {
  const event = new CustomEvent<ToastEventDetail>('show-toast', {
    detail: { message, type, duration },
  });
  window.dispatchEvent(event);
};

export default Toast;
